import { IStatus } from './appointments';
import { IChatData } from './chats';
import { TConvertKeys, TNullable } from './common';
import { TUserRoleInstitutionSettings, TUserSummary } from './user';

export enum ENotificationAppointmentsType {
  APPOINTMENT_REQUESTED = 'appointment_requested',
  APPOINTMENT_UPDATED = 'appointment_updated',
  APPOINTMENT_CANCELED = 'appointment_canceled',
  APPOINTMENT_EXPIRED = 'appointment_expired',
  APPOINTMENT_REMINDER = 'appointment_reminder',
  APPOINTMENT_REASSIGNED = 'appointment_reassigned',
  APPOINTMENT_FOLLOW_UP_REQUESTED = 'appointment_follow_up_requested',
  WAITING_ROOM_JOINED = 'waiting_room_joined',
  PAYMENT_REMINDER = 'payment_reminder',
  APPOINTMENT_RESCHEDULE_DECLINED = 'appointment_reschedule_declined',
}

export interface INotificationAppointments {
  created_at: string;
  id: string;
  meta: {
    appointment_id: string;
    start: string;
    end: string;
    status: IStatus[];
    former_provider_user_institution_role_id: string;
    former_provider?: Partial<TUserSummary>;
  };
  read_at: TNullable<string>;
  type: ENotificationAppointmentsType;
  user_institution_role: Omit<TUserRoleInstitutionSettings, 'notifications'>;
}

export enum ENotificationMeetingType {
  CHAT_REQUESTED = 'chat_requested',
}

interface INotificationMeeting {
  id: string;
  type: ENotificationMeetingType;
  meta: {
    chat: Pick<
      IChatData,
      'appointment_id' | 'created_at' | 'id' | 'participants' | 'encounter_id'
    > & { document_ids: TNullable<string[]> };
  };
}

export enum ENotificationActionType {
  LOGOUT = 'logout',
}

interface INotificationAction {
  type: ENotificationActionType;
}

type TNotification =
  INotificationAppointments | INotificationMeeting | INotificationAction;

export type TNotificationCamel = TConvertKeys<TNotification>;
export type TNotificationAppointmentsCamel =
  TConvertKeys<INotificationAppointments>;
